import { memo } from "react";

import Instagram from "../../../../../public/assets/icon/sns/instagram.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const InstagramIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Instagram });
	return <Icon />;
};

export default memo(InstagramIcon);
